import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EmailModule from '../pages/email/EmailModule';
import EmailDashboard from '../pages/email/dashboard/EmailDashboard';
import EmailTemplates from '../pages/email/templates/EmailTemplates';
import EmailTemplateEditor from '../pages/email/templates/EmailTemplateEditor';
import EmailCampaigns from '../pages/email/campaigns/EmailCampaigns';
import EmailCampaignCreate from '../pages/email/campaigns/EmailCampaignCreate';
import EmailCampaignDetail from '../pages/email/campaigns/EmailCampaignDetail';
import EmailPreferences from '../pages/email/preferences/EmailPreferences';
import SenderProfile from '../pages/email/settings/SenderProfile';
import CustomDomain from '../pages/email/settings/CustomDomain';
import EmailConfig from '../pages/email/config/EmailConfig';
import { useUserContext, hasPageAccess } from '../context/userContext';

// Page guard for individual email sub-pages
const EmailPageGuard = ({ pageKey, children }) => {
  const { userCtx } = useUserContext();
  // If context hasn't loaded yet or user has no pages restriction (super admin), allow
  if (!userCtx || !userCtx.pages) return children;
  if (hasPageAccess(userCtx, pageKey)) return children;
  // Redirect to email dashboard if sub-page not allowed
  return <Navigate to="/dashboard/email" replace />;
};

const EmailRoute = () => (
  <Routes>
    <Route element={<EmailModule />}>
      <Route index element={<EmailPageGuard pageKey="email_dashboard"><EmailDashboard /></EmailPageGuard>} />
      <Route path="templates" element={<EmailPageGuard pageKey="email_templates"><EmailTemplates /></EmailPageGuard>} />
      <Route path="templates/new" element={<EmailPageGuard pageKey="email_templates"><EmailTemplateEditor /></EmailPageGuard>} />
      <Route path="templates/:id/edit" element={<EmailPageGuard pageKey="email_templates"><EmailTemplateEditor /></EmailPageGuard>} />
      <Route path="campaigns" element={<EmailPageGuard pageKey="email_campaigns"><EmailCampaigns /></EmailPageGuard>} />
      <Route path="campaigns/new" element={<EmailPageGuard pageKey="email_campaigns"><EmailCampaignCreate /></EmailPageGuard>} />
      <Route path="campaigns/:id/edit" element={<EmailPageGuard pageKey="email_campaigns"><EmailCampaignCreate /></EmailPageGuard>} />
      <Route path="campaigns/:id" element={<EmailPageGuard pageKey="email_campaigns"><EmailCampaignDetail /></EmailPageGuard>} />
      <Route path="preferences" element={<EmailPageGuard pageKey="email_settings"><EmailPreferences /></EmailPageGuard>} />
      {/* Settings — Sender Profile, Custom Domain, Provider Config */}
      <Route path="settings/sender-profile" element={<EmailPageGuard pageKey="email_sender"><SenderProfile /></EmailPageGuard>} />
      <Route path="settings/custom-domain" element={<EmailPageGuard pageKey="email_sender"><CustomDomain /></EmailPageGuard>} />
      <Route path="settings/config" element={<EmailPageGuard pageKey="email_settings"><EmailConfig /></EmailPageGuard>} />
      <Route path="*" element={<Navigate to="/dashboard/email" replace />} />
    </Route>
  </Routes>
);

export default EmailRoute;
